import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {
  body2,
  colors,
  Caption,
  heading4,
  heading5,
  fontWeights,
  smallShadow,
  spacing,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Button } from 'ui/button';

export const StyledButtonPill = styled(Button)`
  border-radius: ${spacing.base};
`;

export const StyledSuggestionButton = styled(StyledButtonPill)`
  margin-left: ${spacing.fiveEights};
`;

export const StyledButtonText = styled.div`
  ${body2}
  color: ${colors.purple100};
`;

export const ColorText = styled.div`
  ${heading4}
  margin-top: ${spacing.threeQuarter};
  background: linear-gradient(
    242.03deg,
    #ff4d80 6.53%,
    #fe4d81 11.5%,
    #fc4e82 16.47%,
    #f95086 21.44%,
    #f4528a 26.41%,
    #ee5490 31.38%,
    #e65897 36.35%,
    #de5b9f 41.31%,
    #d65fa7 46.28%,
    #ce62af 51.25%,
    #c666b6 56.22%,
    #c068bc 61.19%,
    #bb6ac0 66.16%,
    #b86cc4 71.13%,
    #b66dc5 76.1%,
    #b56dc6 81.07%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledContentHeading = styled.div`
  ${heading5}
  padding-bottom: ${spacing.plusQuarter}
`;

export const Details = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  /** unicode for bullet operators */
  > * + * {
    ::before {
      color: ${colors.grey35};
      content: '\\2219'; /** unicode for bullet operators */
      margin-right: ${spacing.quarter};
      font-weight: ${fontWeights.semiBold};
    }
    margin-left: ${spacing.quarter};
  }
`;

export const StyledNBACampaignsList = styled.div`
  ${smallShadow};
  background: ${colors.white};
  border-radius: ${spacing.half};
  > div:not(:first-child) {
    border-top: ${spacing.single} solid ${colors.grey10};
  }
`;

export const StyledGradientMaskContainer = styled.div`
  position: relative;
`;
export const StyledGradientMask = styled.div`
  z-index: 3;
  position: absolute;
  height: 110%;
  width: 110%;
  top: 0;
  left: -22px;
  background: linear-gradient(180deg, rgb(250 250 250 / 0) 30%, ${colors.grey1} 86%);
`;

export const StyledNBACampaignsListItem = styled.div`
  ${body2}
  cursor: pointer;
  padding: ${spacing.base};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledNBACampaignsItemsSkeleton = styled(StyledNBACampaignsListItem)`
  justify-content: normal;
`;

export const StyledSkeletonWrapper = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  flex-direction: column;
`;

export const StyledSecondaryCaption = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const StyledLink = styled(Link)`
  color: ${colors.textPrimary};
  &:hover {
    text-decoration: none;
    color: ${colors.textPrimary};
  }
  padding-left: ${spacing.fiveEights};
`;

export const StyledTruncatedText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${pxToRem(200)};
`;

export const StyledCampaignPreviewThumbnail = styled.div`
  > a > div {
    margin-right: ${spacing.fiveEights};
  }
`;

export const StyledButtonContainer = styled.div`
  position: relative;
`;
